import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { courses } from './data';
import "./styles.css";
import CourseMaterial from '../../Components/CourseMaterial';
import Chat from '../../Components/Chat';
import RequestReview from '../../Components/RequestReview';
import axios from 'axios';
import { MAIN_URL } from '../../constants';
import api from '../../Components/RefreshToken/RefreshToken';
import { MessageSquareWarning } from 'lucide-react';
import { Card, EmptyState, PageHeader, SegmentedControl, Skeleton } from '../../Components/ui';
import ComplaintStatus from '../../Components/Chat/ComplaintStatus';
import './NotificationsPage.css';

// Faqat ko'rsatish uchun yordamchilar
const PAGE_TITLES = {
    "student-complaints": { title: "Shikoyatlar", subtitle: "Studentlar va mentorlardan kelgan murojaatlar" },
    "teacher-complaints": { title: "Shikoyatlar", subtitle: "Studentlar va mentorlardan kelgan murojaatlar" },
    "student-application": { title: "Student arizalari", subtitle: "Studentlardan kelgan arizalar" },
    confirmations: { title: "Tasdiqlashlar", subtitle: "Mentor tasdiqlashi kerak bo'lgan materiallar" },
};

// Mentor shikoyatlarida `user` yo'q (API sxemasi) — ism `mentor` dan olinadi.
const getSender = (item) => item?.user || item?.mentor || null;
const getSenderName = (item) => {
    const person = getSender(item);
    return [person?.first_name, person?.last_name].filter(Boolean).join(' ');
};
const getInitials = (name) => name.split(' ').filter(Boolean).slice(0, 2).map((part) => part[0]).join('') || '?';


const headings = {
    confirmations: {
        mainTitle: "Confirmations",
        contentTitle: "Courses"
    },
    "teacher-complaints": {
        mainTitle: "Teacher Complaints",
        contentTitle: "Complaints list"
    },
    "student-complaints": {
        mainTitle: "Student Complaints",
        contentTitle: "Complaints list"
    },
    "student-application": {
        mainTitle: "Student Application",
        contentTitle: "Complaints list"
    }
};

const NotificationPage = () => {
    const [activeCourseId, setActiveCourseId] = useState(null);
    const [lessonDetail, setLessonDetail] = useState(null);
    const [user, setUser] = useState("");
    const TOKEN = localStorage.getItem('admin_token')
    const [studentComplaints, setStudentComplaints] = useState()
    const [mentorComplaints, setMentorComplaints] = useState()
    const navigate = useNavigate()
    const { type } = useParams();
    const [studentApp, setStudentApp] = useState(false)

    const selectCourse = (course) => {
        setActiveCourseId(course.id);
        setLessonDetail(course.lessonData);
        setUser(course);
    };
    const isCourseSelected = !!activeCourseId;

    useEffect(() => {
        api.get(`/management/student/complaints`, {
            headers: {
                "Authorization": `Bearer ${TOKEN}`
            },
        }).then((res) => {
            setStudentComplaints(res?.data)

        }).catch((err) => {
            console.log(err);

        })
    }, [user])

    useEffect(() => {
        api.get(`/management/mentor/complaints`, {
            headers: {
                "Authorization": `Bearer ${TOKEN}`
            },
        }).then((res) => {
            setMentorComplaints(res?.data)
        }).catch((err) => {
            console.log(err);

        })
    }, [])
    useEffect(() => {
        setActiveCourseId(null);
        setUser("");
        if (type === "student-application") {
            setStudentApp(true);
        } else {
            setStudentApp(false);
        }

    }, [type]);

    const handleTabChange = (tab) => {
        navigate(`/notifications/${tab === "students" ? "student-complaints" : "teacher-complaints"}`);
    };
    const page = PAGE_TITLES[type] || { title: "Bildirishnomalar" };
    const list = type === "student-complaints" ? studentComplaints : mentorComplaints;

    let content;
    if (headings[type]?.mainTitle === "Student Application") {
        content = (
            <div className='dynamic-component'>
                {studentApp && <RequestReview user={user} />}
            </div>
        );
    } else if (type === "confirmations" || !headings[type]) {
        // Tasdiqlashlar bo'limi hozircha ishlamaydi (CourseMaterial soxta ma'lumot bilan) — docs/known-issues.md
        content = (
            <Card padding="none">
                <EmptyState
                    title={type === "confirmations" ? "Tasdiqlashlar hozircha mavjud emas" : "Bunday bo'lim topilmadi"}
                    description={type === "confirmations" ? "Bu bo'lim hali ishga tushirilmagan" : undefined}
                />
            </Card>
        );
    } else {
        content = (
            <>
                <SegmentedControl
                    aria-label="Shikoyatlar turi"
                    className="ui-complaints__tabs"
                    options={[
                        { value: "students", label: "Studentlardan" },
                        { value: "mentors", label: "Mentorlardan" },
                    ]}
                    value={type === "student-complaints" ? "students" : "mentors"}
                    onChange={(tab) => handleTabChange(tab)}
                />

                <div className={`ui-complaints__layout ${isCourseSelected ? "ui-complaints__layout--selected" : ""}`}>
                    <div className="ui-complaints__list">
                        {list === undefined ? (
                            [0, 1, 2, 3].map((i) => (
                                <div key={i} className="ui-complaints__item ui-complaints__item--skeleton" aria-hidden="true">
                                    <Skeleton width={36} height={36} radius="full" />
                                    <div className="ui-complaints__item-body">
                                        <Skeleton width="50%" height={14} />
                                        <Skeleton width="85%" height={12} />
                                    </div>
                                </div>
                            ))
                        ) : list.length === 0 ? (
                            <Card padding="none">
                                <EmptyState icon={<MessageSquareWarning />} title="Shikoyatlar yo'q" />
                            </Card>
                        ) : (
                            list.map((course) => {
                                const name = getSenderName(course);
                                return (
                                    <button
                                        type="button"
                                        key={course.id}
                                        className={`ui-complaints__item ${activeCourseId === course.id ? 'ui-complaints__item--active' : ''}`}
                                        onClick={() => selectCourse(course)}
                                    >
                                        <span className="ui-complaints__avatar" aria-hidden="true">{getInitials(name)}</span>
                                        <span className="ui-complaints__item-body">
                                            <span className="ui-complaints__item-top">
                                                <span className="ui-complaints__name">{name || "Noma'lum"}</span>
                                                <span className="ui-complaints__date">
                                                    {new Date(course.date_time).toLocaleDateString("ru-RU")}
                                                </span>
                                            </span>
                                            {course?.title && <span className="ui-complaints__subject">{course.title}</span>}
                                            {course?.description && <span className="ui-complaints__text">{course.description}</span>}
                                            <span className="ui-complaints__item-bottom">
                                                {course?.course?.title && <span className="ui-complaints__course">{course.course.title}</span>}
                                                <ComplaintStatus reviewed={course?.reviewed} />
                                            </span>
                                        </span>
                                    </button>
                                );
                            })
                        )}
                    </div>

                    <div className='dynamic-component ui-complaints__detail'>
                        {headings[type]?.mainTitle === "Confirmations" && lessonDetail ? (
                            <CourseMaterial lessonData={lessonDetail} />
                        ) : (activeCourseId && user) ? (
                            <Chat user={user} />
                        ) : (
                            <Card padding="none" className="ui-complaints__placeholder">
                                <EmptyState icon={<MessageSquareWarning />} title="Shikoyatni tanlang" description="Tafsilotlarni ko'rish uchun ro'yxatdan shikoyatni bosing" />
                            </Card>
                        )}
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="ui-complaints">
            <PageHeader title={page.title} subtitle={page.subtitle} />
            {content}
        </div>
    );

};
export default NotificationPage;